import React from 'react';
interface SectionHeaderProps {
  icon: ReactNode;
  children: ReactNode;
}
export function SectionHeader({
  icon,
  children
}: SectionHeaderProps) {
  return <h2 className="text-xl sm:text-2xl font-bold flex items-center gap-2 my-4 border-b border-gray-200 pb-2" data-id="element-255">
      <span className="text-gray-700" data-id="element-256">{icon}</span>
      <span data-id="element-257">{children}</span>
    </h2>;
}